/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on all pages

    $(".button-callback").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      $("body").addClass("popin-active");
      $("#popup-callback").addClass("show");
    });

    $(document).click(function (event) {
      if (
        !$(event.target).closest("#popup-callback .popup-content").length &&
        $("body").hasClass("popin-active")
      ) {
        $("body").removeClass("popin-active");
        $("#popup-callback").removeClass("show");
      }
    });

    let acc = $(".accordion");
    if (acc) {
      for (let i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
          if (this.classList.contains("active")) {
            this.classList.remove("active");
            this.nextElementSibling.style.maxHeight = null;
          } else {
            for (let y = 0; y < acc.length; y++) {
              acc[y].classList.remove("active");
              let panel = acc[y].nextElementSibling;
              panel.style.maxHeight = null;
            }
            this.classList.add("active");
            this.nextElementSibling.style.maxHeight =
              this.nextElementSibling.scrollHeight + "px";
          }
          this.scrollIntoView({ behavior: "smooth" });
        });
      }
    }

    let open = $(".action-open");
    let close = $(".action-close");
    let closeSub = $(".action-close-sub");
    let openSub = $(".open-sub-mobile");
    let backSub = $(".back-sub");
    let linkSub = $(".sub-child");
    if (open) {
      open.click(function () {
        $("#ml-menu").toggleClass("menu--open");
        $("body").toggleClass("menu--open");
      });
    }
    if (close) {
      close.click(function () {
        $("#ml-menu").toggleClass("menu--open");
        $("body").toggleClass("menu--open");
      });
    }
    if (closeSub) {
      closeSub.click(function () {
        $("#ml-menu").toggleClass("menu--open");
        $(this).closest(".has-sub").find(".childs-block").toggleClass("closed");
        $("body").toggleClass("menu--open");
      });
    }
    if (openSub) {
      openSub.click(function () {
        $(this).closest(".has-sub").find(".childs-block").toggleClass("closed");
      });
    }
    if (backSub) {
      backSub.click(function () {
        $(this).closest(".has-sub").find(".childs-block").toggleClass("closed");
      });
    }
    if (linkSub) {
      linkSub.click(function () {
        $("#ml-menu").removeClass("menu--open");
        $("body").removeClass("menu--open");
      });
    }

    let subs = $(".child-title");
    if (subs) {
      for (let x = 0; x < subs.length; x++) {
        subs[x].addEventListener("click", function () {
          for (let y = 0; y < subs.length; y++) {
            subs[y].nextElementSibling.classList.remove("active");
            subs[y].nextElementSibling.style.maxHeight = "0px";
          }
          this.nextElementSibling.classList.add("active");
          this.nextElementSibling.style.maxHeight =
            this.nextElementSibling.scrollHeight + "px";
        });
      }
    }

    var mlmenu, menuEl, myIntervalSubMenu;
    var clickHandler = "ontouchstart click";

    $(document).ready(function () {
      // Hide element filtered
      $(".team-member")
        .hide()
        .each(function (i, obj) {
          if ($(obj).hasClass($(".filters .filter").attr("data-filter"))) {
            $(obj).show();
          }
        });

      $(".category-post #actu .post-actu-wrapper")
        .hide()
        .each(function (i, obj) {
          if ($(obj).hasClass($(".filters .filter").attr("data-filter"))) {
            $(obj).show();
          }
        });

      // Add class filter--active active on first element
      //$('.filters .filter').first().addClass('filter--active');

      // On click, add class filter--active on element clicked
      $(".filters .filter").click(function (event) {
        $(".filters .filter").removeClass("filter--active");
        if ($(event.target).hasClass("filter--active")) {
          $(event.target).removeClass("filter--active");
        } else {
          $(event.target).addClass("filter--active");
        }

        // Transition element filtered
        $(".team-member")
          .fadeOut(200)
          .delay(200)
          .each(function (i, obj) {
            if ($(obj).hasClass($(event.target).attr("data-filter"))) {
              $(obj).fadeIn(1000);
            }
          });

        // $('.category-post #actu .post-actu-wrapper').fadeOut(200).delay(200).each(function (i, obj) {
        //     if ($(obj).hasClass($(event.target).attr('data-filter'))) {
        //         $(obj).fadeIn(1000);
        //     }
        // });
      });

      if ($(".slider-img-job")) {
        $(".slider-img-job").slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow:
            '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
          nextArrow:
            '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }

      $(".your-file").each(function () {
        var $input = $("input[type=file]", this),
          $label = $("+ label", this),
          labelVal = $label.html();

        console.log($input);

        $input.on("change", function (e) {
          var fileName = "";

          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          else if (e.target.value) fileName = e.target.value.split("\\").pop();

          if (fileName)
            $label.html('<i class="fas fa-file-upload"></i> ' + fileName);
          else $label.html(labelVal);
        });

        // Firefox bug fix
        $input
          .on("focus", function () {
            $input.addClass("has-focus");
          })
          .on("blur", function () {
            $input.removeClass("has-focus");
          });
      });

      if ($(".testimonials-slider")) {
        $(".testimonials-slider").slick({
          autoplay: true,
          autoplaySpeed: 5000,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          prevArrow: $(".prev-testi"),
          nextArrow: $(".next-testi"),
        });
      }

      if ($(".slider-solution")) {
        $(".slider-solution").slick({
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 5,
          centerMode: true,
          slidesToScroll: 1,
          infinite: true,
          prevArrow: $(".prev-service"),
          nextArrow: $(".next-service"),
          variableWidth: false,
          responsive: [
            {
              breakpoint: 1325,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: false,
              },
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: false,
              },
            },
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: false,
              },
            },
          ],
        });
      }

      if ($(".slider-partners")) {
        $(".slider-partners").slick({
          arrows: false,
          slidesToShow: 6,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 5,
                rows: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
                rows: 2,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }

      if ($(window).width() < 550 && $("#actus-list")) {
        $("#actus-list").slick({
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          swipe: true,
          swipeToSlide: true,
        });
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/routes/common.js